<!--
// app/components/Shared/SocialIcons.vue
-->
<script setup lang="ts">
import InstagramIcon from "~/components/Shared/icons/InstagramIcon.vue";
import TwitterIcon from "~/components/Shared/icons/TwitterIcon.vue";
import TikTokIcon from "~/components/Shared/icons/TikTokIcon.vue";
import YoutubeIcon from "~/components/Shared/icons/YoutubeIcon.vue";
import TwitchIcon from "~/components/Shared/icons/TwitchIcon.vue";
import type { SocialMediaNames } from "#shared/region/domain/models/Region";
import DiscordIcon from "~/components/Shared/icons/DiscordIcon.vue";
import FacebookIcon from "~/components/Shared/icons/FacebookIcon.vue";
import KickIcon from "~/components/Shared/icons/KickIcon.vue";

type Props = {
  width?: number | string;
  height?: number | string;
  socialProfiles: { [key in SocialMediaNames]?: string | undefined };
};

withDefaults(defineProps<Props>(), {});
</script>

<template>
  <div class="flex items-center justify-start gap-3.5">
    <span v-if="socialProfiles.twitch"
      ><twitch-icon :profile-link="socialProfiles.twitch" :height="height" :width="width"></twitch-icon
    ></span>
    <span v-if="socialProfiles.discord"
      ><discord-icon :profile-link="socialProfiles.discord" :height="height" :width="width"></discord-icon
    ></span>
    <span v-if="socialProfiles.twitter"
      ><twitter-icon :profile-link="socialProfiles.twitter" :height="height" :width="width"></twitter-icon
    ></span>
    <span v-if="socialProfiles.instagram"
      ><instagram-icon
        :profile-link="socialProfiles.instagram"
        :height="height"
        :width="width"
      ></instagram-icon
    ></span>
    <span v-if="socialProfiles.tiktok"
      ><tik-tok-icon :profile-link="socialProfiles.tiktok" :height="height" :width="width"></tik-tok-icon
    ></span>
    <span v-if="socialProfiles.youtube"
      ><youtube-icon :profile-link="socialProfiles.youtube" :height="height" :width="width"></youtube-icon
    ></span>
    <span v-if="socialProfiles.facebook"
      ><facebook-icon :profile-link="socialProfiles.facebook" :height="height" :width="width"></facebook-icon
    ></span>
    <span v-if="socialProfiles.kick"
      ><kick-icon :profile-link="socialProfiles.kick" :height="height" :width="width"></kick-icon
    ></span>
  </div>
</template>

<style scoped></style>
